var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.userIsAdmin
        ? _c(
            "v-btn",
            {
              staticClass: "add-person-button",
              attrs: { color: "primary", outlined: "", light: "" },
              nativeOn: {
                click: function($event) {
                  $event.stopPropagation()
                  _vm.addPersonOpen = !_vm.addPersonOpen
                }
              }
            },
            [_vm._v("\n      Add Person\n    ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "" },
          model: {
            value: _vm.addPersonOpen,
            callback: function($$v) {
              _vm.addPersonOpen = $$v
            },
            expression: "addPersonOpen"
          }
        },
        [
          _c(
            "v-form",
            {
              ref: "addPersonForm",
              model: {
                value: _vm.addPersonFormIsValid,
                callback: function($$v) {
                  _vm.addPersonFormIsValid = $$v
                },
                expression: "addPersonFormIsValid"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", { staticClass: "headline" }, [
                    _vm._v("Add New Person?")
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { "px-3": "" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "E-mail",
                          rules: _vm.validationRules.emailRequiredValidUnique,
                          required: ""
                        },
                        on: { blur: _vm.emailIsUnique },
                        model: {
                          value: _vm.newEmail,
                          callback: function($$v) {
                            _vm.newEmail = $$v
                          },
                          expression: "newEmail"
                        }
                      }),
                      _vm._v(" "),
                      _c("v-text-field", {
                        attrs: {
                          label: "First Name",
                          rules: _vm.validationRules.nameRequiredValid,
                          counter: 15,
                          required: ""
                        },
                        model: {
                          value: _vm.newFirstName,
                          callback: function($$v) {
                            _vm.newFirstName = $$v
                          },
                          expression: "newFirstName"
                        }
                      }),
                      _vm._v(" "),
                      _c("v-text-field", {
                        attrs: {
                          label: "Last Name",
                          rules: _vm.validationRules.nameRequiredValid,
                          counter: 15,
                          required: ""
                        },
                        model: {
                          value: _vm.newLastName,
                          callback: function($$v) {
                            _vm.newLastName = $$v
                          },
                          expression: "newLastName"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c(
                        "v-flex",
                        { attrs: { "p-6": "" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { disabled: !_vm.addPersonFormIsValid },
                              on: {
                                click: function($event) {
                                  return _vm.addPerson(
                                    _vm.newEmail,
                                    _vm.newFirstName,
                                    _vm.newLastName
                                  )
                                }
                              }
                            },
                            [_vm._v("Add")]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              on: {
                                click: function($event) {
                                  _vm.clearAddDialogFields()
                                  _vm.addPersonOpen = false
                                }
                              }
                            },
                            [_vm._v("Cancel")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5164f0e6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5164f0e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/People/AddPerson.vue
// module id = TrJJ
// module chunks = 1